import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Stop = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M3.5625 11.9985C3.5625 14.2363 4.45145 16.3824 6.03379 17.9647C7.61612 19.5471 9.76224 20.436 12 20.436C14.2378 20.436 16.3839 19.5471 17.9662 17.9647C19.5486 16.3824 20.4375 14.2363 20.4375 11.9985C20.4375 9.76077 19.5486 7.61466 17.9662 6.03232C16.3839 4.44998 14.2378 3.56104 12 3.56104C9.76224 3.56104 7.61612 4.44998 6.03379 6.03232C4.45145 7.61466 3.5625 9.76077 3.5625 11.9985V11.9985Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.1875 9.18604H14.8125V14.811H9.1875V9.18604Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
